import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  background: var(--primary);
  color: var(--white);
  border: 0;
  padding: 0.5em 1em;
  border-radius: 5px;
  transition: background-color 200ms;
  cursor: pointer;
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.5);
  transform: translateY(0);
  font-size: ${({ big }) => (big ? '1rem' : '0.8rem')};
  font-weight: bold;
  &:hover,
  &:focus {
    background: #3482e8cf;
  }
  &:disabled {
    background-color: #9e9b9bb5;
    cursor: not-allowed;
  }
`;

function Button({ big = false, disabled, children, onClick }) {
  return (
    <StyledButton onClick={onClick} big={big} disabled={disabled}>
      {children}
    </StyledButton>
  );
}

export default Button;
